import {
  GET_CUSTOMER_DETAIL_DATA,
  GET_CUSTOMER_DETAIL_DATA_FAILURE,
  GET_CUSTOMER_DETAIL_DATA_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCustomerDetailProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_DETAIL_DATA:
      return { ...state, loading: true };
    case GET_CUSTOMER_DETAIL_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CUSTOMER_DETAIL_DATA_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCustomerDetailProviderReducer;
